import React, { useState, useEffect, memo } from 'react';
import { TakeParentSpace } from './styled';
import { AudioChatBallon } from 'components/Conversation/ChatBallons/styled';
import { FaFileAlt } from 'react-icons/fa';

const GeneralTypesOfMediaEnum = {
  IMAGE: 'IMAGE',
  AUDIO: 'AUDIO',
  VIDEO: 'VIDEO',
  FILE: 'FILE'
};

function getTypeOfMedia(file) {
  const mimeType = file.type;

  if (mimeType.startsWith('image')) return GeneralTypesOfMediaEnum.IMAGE;
  if (mimeType.startsWith('audio')) return GeneralTypesOfMediaEnum.AUDIO;
  if (mimeType.startsWith('video')) return GeneralTypesOfMediaEnum.VIDEO;

  return GeneralTypesOfMediaEnum.FILE;
}

/**
 * @param {Object} props
 * @param {(File | null | string) | Promise<(File | null | string)>} props.file
 * @param {Function} [props.onFileResolved]
 */
export const FlexMediaPreviewer = memo(
  ({ file, onFileResolved }) => {
    const [resolvedFile, setResolvedFile] = useState(null);
    useEffect(() => {
      let isMounted = true;

      const resolveFile = async () => {
        let resolved = file instanceof Promise ? await file : file;

        // Se for uma string (URL), faz o fetch e cria o File
        if (typeof resolved === 'string') {
          try {
            const response = await fetch(resolved);
            const blob = await response.blob();
            const filename = resolved.split('/').pop() || 'arquivo';
            resolved = new File([blob], filename, { type: blob.type });
          } catch (error) {
            console.error('Erro ao buscar o arquivo da URL:', error);
            resolved = null;
          }
        }

        if (isMounted) {
          setResolvedFile(resolved);
          if (onFileResolved) {
            onFileResolved(resolved);
          }
        }
      };

      resolveFile();

      return () => {
        isMounted = false;
      };
    }, [file, onFileResolved]);

    if (
      !resolvedFile ||
      !(typeof resolvedFile === 'object' && 'type' in resolvedFile)
    )
      return <div>Nenhum arquivo recebido</div>;

    const mediaType = getTypeOfMedia(resolvedFile);
    const objectUrl = URL.createObjectURL(resolvedFile);

    const isPdf = resolvedFile.type === 'application/pdf';

    return (
      <TakeParentSpace>
        {mediaType === GeneralTypesOfMediaEnum.IMAGE && (
          <img src={objectUrl} alt="Imagem da mídia" />
        )}
        {mediaType === GeneralTypesOfMediaEnum.AUDIO && (
          <AudioChatBallon controls src={objectUrl} />
        )}
        {mediaType === GeneralTypesOfMediaEnum.VIDEO && (
          <video controls src={objectUrl} />
        )}
        {mediaType === GeneralTypesOfMediaEnum.FILE &&
          (isPdf ? (
            <iframe src={objectUrl} title="Arquivo" />
          ) : (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '20px',
                border: '1px dashed #ccc',
                borderRadius: '8px',
                backgroundColor: '#f9f9f9'
              }}
            >
              <FaFileAlt size={40} color="#525f7f" />
              <span
                style={{
                  marginTop: '10px',
                  fontSize: '0.9rem',
                  color: '#333',
                  textAlign: 'center',
                  wordBreak: 'break-all'
                }}
              >
                {resolvedFile.name}
              </span>
            </div>
          ))}
      </TakeParentSpace>
    );
  },
  (prev, next) => JSON.stringify(prev) === JSON.stringify(next)
);

FlexMediaPreviewer.displayName = 'FlexMediaPreviewer';
